"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../../../common/constants/states");
var saveToDisk_1 = require("../../../../../common/helpers/saveToDisk");
var splitFormDataByFile_1 = require("../../../../../common/helpers/splitFormDataByFile");
var permitImages_1 = require("../../../../../common/helpers/permitImages");
var AdminStudentFilesController = /** @class */ (function () {
    function AdminStudentFilesController($state, $stateParams, UsersModel, FlashService, FilesModel, $q, PoliciesStoreService) {
        var _this = this;
        this.initialLoad = true;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.submitted = false;
        this.FilesModel = FilesModel;
        this.files = [];
        this.$q = $q;
        this.submitting = false;
        this.requirePermitImages = (0, permitImages_1.permitImagesRequired)(PoliciesStoreService);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handlePermitFrontUpload = this.handlePermitFrontUpload.bind(this);
        this.handlePermitBackUpload = this.handlePermitBackUpload.bind(this);
        this.selectFileType = this.selectFileType.bind(this);
        //
        this.fileType = "";
        this.fileName = "";
        //
        UsersModel.getFiles(this.$stateParams.userId).then(function (response) {
            _this.files = response.files;
        });
    }
    AdminStudentFilesController.prototype.selectFileType = function (fileType) {
        this.fileType = fileType;
    };
    AdminStudentFilesController.prototype.handleFileUpload = function (formData) {
        var _this = this;
        this.submitting = true;
        var promises = [];
        formData.entries().forEach(function (entry) {
            var fd = new FormData();
            var file = entry[1];
            fd.append("file", file, file.name);
            fd.append("students", JSON.stringify([_this.$stateParams.userId]));
            promises.push(_this.FilesModel.uploadFile(_this.fileType, file.name, fd));
        });
        this.$q
            .all(promises)
            .then(function (responses) {
            responses.forEach(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.files.push(response.file);
            });
            _this.submitting = false;
            _this.fileType = "";
        })
            .catch(function (Error) {
            console.log(Error);
            _this.submitting = false;
            _this.fileType = "";
        });
    };
    AdminStudentFilesController.prototype.frontImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_FRONT_TYPE);
    };
    AdminStudentFilesController.prototype.backImage = function () {
        return (0, permitImages_1.permitImageOfType)(this.files, permitImages_1.PERMIT_BACK_TYPE);
    };
    AdminStudentFilesController.prototype.handlePermitFrontUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_FRONT_TYPE);
    };
    AdminStudentFilesController.prototype.handlePermitBackUpload = function (formData) {
        this.uploadPermitImage(formData, permitImages_1.PERMIT_BACK_TYPE);
    };
    AdminStudentFilesController.prototype.uploadPermitImage = function (formData, fileType) {
        var _this = this;
        var uploads = (0, splitFormDataByFile_1.splitFormDataByFile)(formData).map(function (singleFileFormData) {
            singleFileFormData.append("students", JSON.stringify([_this.$stateParams.userId]));
            return _this.FilesModel.uploadFile(fileType, fileType, singleFileFormData);
        });
        this.$q
            .all(uploads)
            .then(function (responses) {
            responses.forEach(function (response) {
                _this.files.push(response.file);
            });
        })
            .catch(function (Error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Something went wrong uploading the file.",
            });
        });
    };
    AdminStudentFilesController.prototype.formatDate = function (datestring) {
        return new Date(datestring).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };
    AdminStudentFilesController.prototype.deleteFile = function (id) {
        var _this = this;
        this.FilesModel.destroy(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.files = _this.files.filter(function (file) {
                return file.id !== id;
            });
        })
            .catch(function (Error) { });
    };
    AdminStudentFilesController.prototype.downloadFile = function (id) {
        var _this = this;
        this.FilesModel.get(id)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.temporary_url);
        })
            .catch(function (Error) { });
    };
    return AdminStudentFilesController;
}());
AdminStudentFilesController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "FilesModel",
    "$q",
    "PoliciesStoreService",
];
exports.default = AdminStudentFilesController;
